module.exports = __webpack_public_path__ + "static/img/xinqiudazhan.24233258.png";